import React from "react";
import { ShieldCheck, Zap, BarChart3, ArrowRight, Star, ChevronDown } from "lucide-react";
import { HERO, waLink } from "../mock";

const chipIcon = { "Verified Results": ShieldCheck, "Instant Setup": Zap, "MT5 Compatible": BarChart3 };

export default function Hero() {
  return (
    <section id="top" className="relative min-h-screen flex items-center overflow-hidden pt-24 pb-16">
      <div className="absolute inset-0">
        <img src={HERO.bg} alt="" className="w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050912]/85 via-[#050912]/80 to-[#050912]" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_75%_30%,rgba(46,155,255,0.18),transparent_55%)]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-12 items-center w-full">
        <div className="reveal in">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-[12.5px] font-medium text-[#9fd0ff] bg-[rgba(46,155,255,0.1)] border border-[rgba(46,155,255,0.3)]">
            <span className="w-2 h-2 rounded-full bg-[#22e39a] live-dot" /> {HERO.badge}
          </span>

          <h1 className="font-display mt-6 text-[3.4rem] leading-[1.05] sm:text-6xl lg:text-[4.6rem] font-bold text-white">
            {HERO.titleLead}<br />
            <span className="text-blue-grad">{HERO.titleHighlight}</span>
          </h1>

          <p className="mt-6 text-slate-300 text-[17px] leading-relaxed max-w-xl">{HERO.subtitle}</p>

          <div className="mt-8 flex flex-wrap gap-4">
            <a href="#pricing" className="btn-primary inline-flex items-center gap-2 px-7 py-3.5 rounded-full font-semibold">
              Get Started Now <ArrowRight className="w-4 h-4" />
            </a>
            <a href="#results" className="btn-ghost inline-flex items-center px-7 py-3.5 rounded-full font-semibold">
              View Live Results
            </a>
          </div>

          <div className="mt-8 flex flex-wrap gap-6">
            {HERO.chips.map((c) => {
              const Icon = chipIcon[c];
              return (
                <span key={c} className="inline-flex items-center gap-2 text-sm text-slate-300">
                  <Icon className="w-4 h-4 text-[#22e39a]" /> {c}
                </span>
              );
            })}
          </div>
        </div>

        <div className="reveal in">
          <div className="glass-card rounded-3xl p-7 relative blue-glow">
            <span className="absolute -top-3 right-6 text-[11px] font-semibold px-3 py-1 rounded-full bg-[#0d1526] border border-[rgba(46,155,255,0.3)]">
              <span className="text-[#22e39a] mr-1">LIVE</span> Profits Running
            </span>
            <p className="text-[12px] tracking-widest text-slate-400 flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-[#22e39a] live-dot" /> LIVE MT5 PERFORMANCE
            </p>
            <div className="text-center py-5">
              <div className="font-display text-6xl font-bold text-blue-grad">{HERO.stat.profit}</div>
              <p className="text-slate-400 text-sm mt-1">Monthly Profit (Verified)</p>
            </div>
            <div className="grid grid-cols-3 gap-3 text-center border-t border-white/5 pt-5">
              <div><div className="font-display text-2xl font-bold text-white">{HERO.stat.subscribers}</div><p className="text-[11px] text-slate-400 mt-1">Subscribers</p></div>
              <div><div className="font-display text-2xl font-bold text-white">{HERO.stat.activeUsers}</div><p className="text-[11px] text-slate-400 mt-1">Active Users</p></div>
              <div><div className="font-display text-2xl font-bold text-white">{HERO.stat.winRate}</div><p className="text-[11px] text-slate-400 mt-1">Win Rate</p></div>
            </div>
            <div className="flex items-center justify-between border-t border-white/5 mt-5 pt-4">
              <div>
                <div className="flex gap-0.5">{[...Array(5)].map((_, i) => <Star key={i} className={`w-4 h-4 ${i < 4 ? "fill-[#2e9bff] text-[#2e9bff]" : "fill-[#2e9bff]/40 text-[#2e9bff]/40"}`} />)}</div>
                <p className="text-sm font-semibold text-white mt-1">{HERO.stat.rating}</p>
                <p className="text-[11px] text-slate-400">{HERO.stat.reviews}</p>
              </div>
              <div className="text-right">
                <div className="text-[#22e39a] font-bold">{HERO.stat.returns}</div>
                <p className="text-[11px] text-slate-400">Monthly returns</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex flex-col items-center text-slate-500 text-[11px] tracking-widest">
        SCROLL <ChevronDown className="w-4 h-4 mt-1 animate-bounce" />
      </div>
    </section>
  );
}
